import { useAccountFxPreferences } from '../contexts/AccountFxPreferences.jsx';
import { usePrefersReducedMotion } from './usePrefersReducedMotion.js';
import { effectiveReduceEffects } from '../_helpers/fxReduceEffects.js';

/**
 * Whether stream effects play reduced right now (ENG-836): the effective
 * value, not the switch. On when the account's Photosensitivity mode is on,
 * while the account state is still loading or failed to load, while the
 * first-login warning is open, or while the device asks for reduced motion
 * (followed live, never saved). See `effectiveReduceEffects`.
 *
 * The ENG-810 localStorage key is not read: the account is the one setting.
 */
export const useReduceEffects = () => {
  const { status, photosensitivityMode, warningOpen } = useAccountFxPreferences();
  const osReducedMotion = usePrefersReducedMotion();
  return effectiveReduceEffects({ status, photosensitivityMode, warningOpen, osReducedMotion });
};

export default useReduceEffects;
